import { motion } from "motion/react";
import { useState } from "react";
import Carrot from "ui/components/icons/Carrot";
import Flag from "ui/components/icons/Flag";
import Menu from "ui/components/menu/menu";
import { CHAT_FLAGS, CHAT_FLAGS_KEYS } from "ui/lib/constants";
import { useFlaggingSystem } from "./container";

export const FlaggerMenu = ({ updateActionFlag, room }) => {
  const [error, setError] = useState(false);
  const { isMuted } = useFlaggingSystem();

  const FlagMenu = () => {
    const { actionFlag } = room;
    return (
      <motion.div
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 0 }}
        key={"flag-button"}
        className="z-50 w-full"
      >
        <Menu
          align="left"
          width="full"
          style={{ width: "100%" }}
          buttonProps={{
            className:
              "group py-2 px-4 rounded shadow-button bg-card text-foreground w-full flex-center justify-between",
            // as: "div",
            role: "button",
          }}
          itemClassnames={"text-sm"}
          options={[
            ...CHAT_FLAGS_KEYS.filter(
              (key) => !CHAT_FLAGS[key]?.deprecated
            ).map((value) => ({
              label: CHAT_FLAGS[value]?.label,
              disabled: value === actionFlag,
              value,
            })),
          ]}
          onChange={updateActionFlag}
        >
          <div className="space-x-4 opacity-50 flex-center group-hover:opacity-100">
            <Flag className="w-5" />
            <span>Add Flag</span>
          </div>
          <Carrot className="w-4 opacity-75" />
        </Menu>
      </motion.div>
    );
  };

  return (
    <>
      {!isMuted ? <FlagMenu /> : null}
      {error ? (
        <div className="flex flex-col w-full px-4 py-2 mb-2 border rounded text-charcoal bg-error-100 border-error">
          <span className="">something went wrong</span>
          <span className="text-sm">
            If this issue persists, refresh the page
          </span>
        </div>
      ) : null}
    </>
  );
};
